import { AsyncPipe, NgIf } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { TypographyComponent } from 'components';
import { Observable } from 'rxjs';
import {
	ReportBrandMark,
	ReportThemeService
} from '../../../../services/report-theme.service';

// LIMIT: the projected "Powered by lolly" stays under an agency's own mark —
// dropping it is white-label, a paid entitlement that does not exist yet (T-2407).
@Component({
	standalone: true,
	selector: 'app-report-slide-brand',
	imports: [NgIf, AsyncPipe, TypographyComponent],
	template: `
		<span class="brand" *ngIf="brandMark$ | async as mark">
			<img
				*ngIf="mark.logoSrc"
				class="brand__logo"
				[src]="mark.logoSrc"
				[alt]="mark.agencyName ? '' : 'Agency logo'"
				(error)="hideBrokenLogo($event)"
			/>
			<typography
				*ngIf="mark.agencyName"
				variant="p/xxs_semibold"
				class="brand__name"
			>
				{{ mark.agencyName }}
			</typography>
			<span class="brand__rule" aria-hidden="true"></span>
		</span>
		<ng-content></ng-content>
	`,
	styles: [
		`
			:host {
				.brand {
					display: inline-flex;
					align-items: center;
					gap: 0.375rem;
					vertical-align: middle;
				}

				.brand__logo {
					display: block;
					height: 1rem;
					max-width: 4.5rem;
					object-fit: contain;
				}

				.brand__name {
					display: block;
					max-width: 8rem;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					color: var(--report-value, #0e1a33);
					font-size: 0.6875rem;
					line-height: 1;
					font-weight: 700;
				}

				.brand__rule {
					width: 1px;
					height: 0.75rem;
					background: var(--report-border, #e6eaf2);
				}

				&.report-slide-brand--cover {
					.brand {
						gap: 0.75rem;
						margin-right: 0.75rem;
					}

					.brand__logo {
						height: 2.25rem;
						max-width: 12rem;
					}

					.brand__name {
						max-width: 20rem;
						font-size: 1.3125rem;
					}

					.brand__rule {
						height: 1.5rem;
					}
				}
			}
		`
	]
})
export class ReportSlideBrandComponent {
	@HostBinding('class.report-slide-brand--cover')
	@Input()
	cover = false;

	readonly brandMark$: Observable<ReportBrandMark | null>;

	constructor(theme: ReportThemeService) {
		this.brandMark$ = theme.brandMark$;
	}

	// TRAP: hidden through the element, not a flag — the PDF export page stops
	// checking its view once it is built, so a template binding would not redraw.
	hideBrokenLogo(event: Event): void {
		(event.target as HTMLImageElement).style.display = 'none';
	}
}
